import React from 'react'
import { Link } from 'react-router-dom'
import Style from './pageState.module.css'

const PageNotice = ({ icon, title, hint, linkTo, linkLabel }) => (
    <div className="main-content">
        <div className="page-content">
            <div className="container-fluid">
                <div className={Style.notice}>
                    <i className={`${icon || 'uil-link-broken'} ${Style.noticeIcon}`} aria-hidden="true" />
                    <p className={Style.noticeTitle}>{title}</p>
                    {hint ? <p className={Style.noticeHint}>{hint}</p> : null}
                    {linkTo ? <Link to={linkTo} className={Style.noticeLink}>{linkLabel}</Link> : null}
                </div>
            </div>
        </div>
    </div>
)

export default PageNotice
